// extracted by mini-css-extract-plugin
module.exports = {"loading":"UIRoot_loading__2mbDr"};